import {checkIfSelectionValid} from '@learningblocks/protocol-constants/lib/Utilities';
// set a question checkbox as selected
export function selectCheckboxOption(state, payload) {
  return {
    ...state,
    currentSection: updateCheckboxInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateCheckboxInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateCheckboxInComponents(currentSection.components, payload),
  };
}

function updateCheckboxInComponents(components, payload) {
  const updateComponent = (component) => {
    if (component.id === payload.componentID) {
      component = updateCheckboxInMSCQComponent(component, payload);
    }
    return component;
  };
  return components.map(updateComponent);
}

function updateCheckboxInMSCQComponent(component, payload) {
  const updateOptionCheckbox = (checkboxOption) => {
    if (checkboxOption.disabled === false || payload.disabled !== null) {
      if (payload.optionID === checkboxOption.id) {
        checkboxOption.selected = payload.checked;
        if(!payload.checked && payload.disabled !== null){
          checkboxOption.disabled = payload.disabled;
        }
      }
    }
    return {...checkboxOption};
  };

  if (checkIfSelectionValid(component)) {
    component.checkboxes = component.checkboxes.map(updateOptionCheckbox);
  }
  return component;
}
